import { publicWatchApi } from "@/data/api";
import { watchSeed } from "@/features/watch/data";

import type { LeagueAchievementLeaderboardPublic } from "@softmax/observatory-client/types";

import { standingsFrom } from "../data/preview-standings";

import type { ResolvedPreviewLeague } from "../preview-league.data";
async function readAchievements(
  leagueId: string,
  signal?: AbortSignal,
): Promise<LeagueAchievementLeaderboardPublic | null> {
  const board = await publicWatchApi({
    signal,
  }).get<LeagueAchievementLeaderboardPublic>(
    `/v2/leagues/${leagueId}/achievements/leaderboard`,
  );
  return board && Array.isArray(board.entries) && Array.isArray(board.catalog)
    ? board
    : null;
}

export async function readPreviewCompetition({
  signal,
  resolved,
  includeDetails,
}: {
  signal?: AbortSignal | undefined;
  resolved: ResolvedPreviewLeague;
  includeDetails: boolean;
}) {
  const { league, corpusSlug, corpus } = resolved;
  const stateRead = includeDetails
    ? watchSeed({
        signal,
        address: { slug: corpusSlug, corpus, viewer: resolved.viewer },
      }).then((seed) =>
        seed.state && seed.state.leagueId === league.id ? seed.state : null,
      )
    : Promise.resolve(null);
  const boardRead = stateRead.then((state) =>
    state && standingsFrom(state.standings).length > 0
      ? readAchievements(league.id, signal)
      : null,
  );

  const [state, board] = await Promise.all([stateRead, boardRead]);
  return { state, board };
}
